import { styled } from 'baseui'
import { FlexColumn } from '@/shared/theme/styled-components'

export const Stack = styled(FlexColumn, {
  gap: '0.75rem',
})

export const FieldsColumn = styled('div', {
  width: '100%',
  marginBottom: '0.75rem',
})

export const ActionsRow = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '0.75rem',
  marginTop: '0.75rem',
})

export const NotificationsWrapper = styled(FlexColumn, {
  marginTop: '0.75rem',
  gap: '0.5rem',
})

export const OutputBox = styled('pre', {
  backgroundColor: '#1e1e1e',
  color: '#d4d4d4',
  padding: '1rem',
  borderRadius: '4px',
  fontFamily: 'Consolas, Monaco, "Courier New", monospace',
  fontSize: '0.8rem',
  lineHeight: '1.6',
  maxHeight: '31rem',
  overflowY: 'auto',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
})
